var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"circle-common",style:({ backgroundColor: _vm.color })},'div',attrs,false),on))]}}],null,false,2933319761)},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.tooltipText || '')}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }